// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://cbbnfjidrgkhrnrgxyoj.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNiYm5mamlkcmdraHJucmd4eW9qIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA3NDI0NDQsImV4cCI6MjA2NjMxODQ0NH0.6s3XWMJ8cV189GcJzr1FTLRvEjevec-7M5LPcORqvVA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});